<template>
  <v-autocomplete
    :id="keyUpTargetId"
    v-model="selectedOptionValue"
    :items="modelListList"
    clearable
    hide-no-data
    hide-selected
    return-object
    :loading="loading"
    :search-input.sync="searchQuery"
    item-value="id"
    :error="searchQuery && searchQuery.length < 2"
    :append-icon="hideSearchIcon || loading ? '' : 'search'"
    item-text="title"
    :label="label"
    persistent-hint
    @click:append="requestData"
    @change="onselectedOptionValueChange"
  />
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import DictionaryMixin from '@/mixins/dictionaryMixin'

export default {
  name: 'WBDDictionarySelectorFilter',
  mixins: [DictionaryMixin],
  props: {
    loadOnStart: {
      type: Boolean,
    },
    hideSearchIcon: {
      type: Boolean,
    },
    label: {
      type: String,
    },
    discr: {
      type: String,
    },
    selectedOptionValueList: {
      type: String,
    },
    remoteList: {
      type: Array,
    },
    onChangeEvent: {
      type: String,
    },
    onResetEvent: {
      type: String,
    },
  },
  data () {
    return {
      loading: false,
      keyUpTargetId: 'dictionaryFilterEltRef',
      searchQuery: null,
      modelListList: [],
      selectedOptionValue: null,
    }
  },
  computed: {
    ...mapGetters({
    }),
  },
  mounted () {
    window.addEventListener('keyup', (event) => {
      if (!(event && event.target && event.target.id === this.keyUpTargetId)) {
        return
      }
      if (event.keyCode === 13) {
        event.preventDefault()
        this.requestData(true)
      }
    })
  },
  created () {
    if (this.remoteList && this.remoteList.length) {
      this.modelListList = this.remoteList
      this.selectedOptionValue = this.remoteList[0]
    }
    this.eventsBus.$on(this.onResetEvent, () => {
      this.selectedModelList = null
      this.searchQuery = null
    })

    if (this.loadOnStart) {
      this.requestData(true)
    }
  },
  methods: {
    ...mapMutations({
    }),
    ...mapActions({
    }),
    async requestData (forceRequest) {
      if (!forceRequest && (!this.searchQuery || this.searchQuery.trim().length < 1)) {
        return
      }
      try {
        this.loading = true
        const params = { 'discr': this.discr, }
        if (this.searchQuery && this.searchQuery.trim() !== '') {
          params.searchQuery = this.searchQuery
        }

        this.modelListList = await this.getDictionaries(
          'DICTIONARY_PATH',
          { params }
        )

        setTimeout(() => {
          this.loading = false
        }, 1500)

        this.loading = false
      } catch (error) {
        this.loading = false
        console.log(error)
      }
    },
    onselectedOptionValueChange () {
      this.$emit(
        this.onChangeEvent,
        this.selectedOptionValue ? this.selectedOptionValue.id : null
      )
    },
  }
}
</script>
